import { render } from "./NavbarElementUpdated.vue?vue&type=template&id=128caafb&scoped=true"
import script from "./NavbarElementUpdated.vue?vue&type=script&lang=js"
export * from "./NavbarElementUpdated.vue?vue&type=script&lang=js"

import "./NavbarElementUpdated.vue?vue&type=style&index=0&id=128caafb&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128caafb"]])

export default __exports__